import { RootState } from '@/index';
import React, { useEffect, useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import IssueApi from '@/fetch/bussiness/issue';
import { CLSTAG, IssueStatus, VehicleSupplier } from '@/utils/constant';
import { Row, Col, Modal, Checkbox, Form, Button } from 'antd';
import { HttpStatusCode } from '@/fetch/core/constant';
import { clstagStr, showMsg } from '@/utils/util';
import './index.scss';
import JiraForm from '../JiraForm/JiraSubmit/JiraForm';
import CommonTitle from '../CommonTitle';
import { isEmpty } from '@/utils';
import Label from '../Label';
import { sendGlobalEvent } from '@/utils/emit';
const fetchApi = new IssueApi();
interface Props {
  open: boolean;
  setOpen: AnyFunc;
  issueNumber: string;
  vehicleName: string;
  vehicleSupplier: string;
}
const CompleteIssueModal = (props: Props) => {
  const [showJira, setShowJira] = useState(false);
  const submitType = useRef<any>(null);
  const [form] = Form.useForm();
  const { open, setOpen, issueNumber, vehicleSupplier } = props;
  const [eventInfo, setEventInfo] = useState<any>({});
  const forceCloseRef = useRef(false);
  const { issueList } = useSelector((state: RootState) => state.workOrder);
  useEffect(() => {
    if (open) {
      getCurrentIssueEventInfo();
    }
  }, [open]);

  const getCurrentIssueEventInfo = async () => {
    try {
      const res = await fetchApi.getIssueEvent({ issueNumber: issueNumber });
      if (res.code === HttpStatusCode.Success) {
        setEventInfo(res.data);
      } else {
        showMsg({
          msg: res.message,
          type: 'error',
        });
      }
    } catch (error) {
      console.error(error);
    }
  };

  const confirmComplete = async (params: {
    acceptNewIssue: boolean;
    forceClose: boolean;
  }) => {
    const { acceptNewIssue, forceClose } = params;
    try {
      const res = await fetchApi.completeIssue({
        acceptNewIssue: acceptNewIssue,
        issueNumber: issueNumber,
        forceClose: forceClose,
        eventCount: eventInfo?.eventCount,
      });
      if (res.code === HttpStatusCode.Success) {
        showMsg({ msg: res.message, type: 'success' });
      } else {
        showMsg({ msg: res.message, type: 'error' });
      }
      setOpen(false);
    } catch (err) {
      console.error(err);
    }
  };
  const getCompleteContent = () => {
    if (eventInfo && !isEmpty(eventInfo.eventList)) {
      for (let event of eventInfo.eventList) {
        if (
          event.eventType !== 'MANUAL_REPORT' &&
          event.eventType !== 'BUG_REPORT'
        ) {
          // 存在非人工告警事件和问题提报工单时展示：
          forceCloseRef.current = true;
          return (
            <>
              当前车辆事件仍有报警事件：
              {eventInfo?.eventList.map((event: any) => {
                return <Label text={event.eventName} key={event.eventName} />;
              })}
              请确认是否结单，结单后，本次的报警事件将不再生成工单，工单状态为“强制关闭”
            </>
          );
        }
      }
      // 所有事件都是人工告警事件时展示：
      forceCloseRef.current = false;
      return <>当前事件均已消失，结单后，工单状态为【已解决】</>;
    } else {
      // 没有事件时展示：
      forceCloseRef.current = false;
      return <>当前事件均已消失，结单后，工单状态为【已解决】</>;
    }
  };

  return (
    <>
      <Modal
        destroyOnHidden
        centered
        title="结单"
        open={open}
        onCancel={() => {
          setOpen(false);
        }}
        footer={
          <>
            <div className="footer" style={{ justifyContent: 'flex-end' }}>
              <div className="operate">
                <Button
                  onClick={() => {
                    setOpen(false);
                  }}
                  style={{
                    marginRight: '12px',
                  }}
                >
                  取消
                </Button>
                <Button
                  type={'primary'}
                  onClick={() => {
                    if (showJira) {
                      submitType.current = 'COMPLETE';
                      sendGlobalEvent('JIRA_SUBMIT');
                    } else {
                      confirmComplete({
                        acceptNewIssue: true,
                        forceClose: forceCloseRef.current,
                      });
                    }
                  }}
                >
                  确认结单
                </Button>
                {issueList &&
                  issueList.find(
                    (item: any) => item.issueStatus === IssueStatus.ON_HOLD
                  ) && (
                    <Button
                      style={{
                        marginLeft: '12px',
                      }}
                      type={'primary'}
                      onClick={() => {
                        if (showJira) {
                          submitType.current = 'COMPLETE_AND_ACCEPT';
                          sendGlobalEvent('JIRA_SUBMIT');
                        } else {
                          confirmComplete({
                            acceptNewIssue: false,
                            forceClose: forceCloseRef.current,
                          });
                        }
                      }}
                    >
                      确定结单并受理挂起工单
                    </Button>
                  )}
              </div>
            </div>
          </>
        }
        maskClosable={false}
        width={showJira ? 1000 : 600}
      >
        <div
          className="content-container"
          style={{ display: 'flex', flexDirection: 'column' }}
        >
          <Row>
            <Col>{getCompleteContent()}</Col>
          </Row>
          {vehicleSupplier === VehicleSupplier.JD && (
            <>
              <Row>
                <Col>
                  <CommonTitle title="关联操作" />
                </Col>
              </Row>
              <Row>
                <Col>
                  <Checkbox
                    checked={showJira}
                    title="提报缺陷"
                    onChange={() => {
                      setShowJira(!showJira);
                    }}
                  >
                    <span clstag={clstagStr(CLSTAG.CompleteIssueJira)}>
                      提报缺陷
                    </span>
                  </Checkbox>
                </Col>
              </Row>
            </>
          )}
          {showJira ? (
            <Row>
              <Col span={24}>
                <JiraForm
                  showFooter={false}
                  form={form}
                  vehicleName={props.vehicleName}
                  closePopoverModel={() => {
                    confirmComplete({
                      acceptNewIssue: submitType.current == 'COMPLETE',
                      forceClose: forceCloseRef.current,
                    });
                  }}
                />
              </Col>
            </Row>
          ) : (
            <></>
          )}
        </div>
      </Modal>
    </>
  );
};

export default CompleteIssueModal;
